import { useEffect } from "react";

const ExternalRedirect = (props) => {
    useEffect(() => {
        console.log("ExternalRedirect-redirectUrl=" + props.redirectUrl);
        window.location.assign(props.redirectUrl);
    }, []);

    return null;
};

export default ExternalRedirect;
